/* unplugin-vue-components disabled */import script from "./organ.vue?vue&type=script&setup=true&lang=ts"
export * from "./organ.vue?vue&type=script&setup=true&lang=ts"

import "./organ.vue?vue&type=style&index=0&id=b36879b6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b36879b6"]])

export default __exports__